import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import cart from './cart'
import history from './history'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    cart, history
  },
  plugins: [vuexLocal.plugin]
})
